import React from 'react'

import { useModalContext } from 'hooks/modal-context'

import { AnimationFadeIn } from 'shared/Animation/Animation'

interface Datas {
  datas: {
    allFlamelinkGalleryContent: {
      nodes: {
        id: number
        alt: string
        width: number
        height: number
        image: {
          url: string
        }[]
      }[]
    }
  }
}

const s = {
  grid: `grid-3 gap-4 mdx:grid-cols-1 mdx:gap-20`,
  link: `w-full h-h40 text-center cursor-pointer lgm:h-h32 mdm:h-h70 smm:h-h28 xsx:h-h32`,
  image: `w-full h-full object-cover`,
  text: `w-full h-fit-content flex justify-center items-center`,
}

const Content = ({ datas }: Datas) => {
  const { setOpenModal, setIndex } = useModalContext()

  const images = datas.allFlamelinkGalleryContent.nodes

  const openClick = (id: number) => {
    setIndex(id)
    setOpenModal(true)
  }

  return (
    <div className={s.grid}>
      {images.flatMap(({ alt, width, height, image }) =>
        image.map(({ url }, idx) => (
          <AnimationFadeIn key={idx} x={0} y={0} delay={300}>
            <div className={s.link} onClick={() => openClick(idx)}>
              <img
                className={s.image}
                src={url}
                alt={alt}
                width={width}
                height={height}
              />
            </div>
          </AnimationFadeIn>
        ))
      )}
    </div>
  )
}

export default Content
